import React from "react";
import { Popover } from "@mui/material";
import "./UserInfoPopover.style.scss";
import { InlineIcon } from "@iconify/react";

interface UserInfoPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  userData: {
    username: string;
    age: number;
    city: string;
    country: string;
    messagesLeft?: string;
    messageMax?: string;
    duration?: string;
    avatar: string;
    hasSubscription?: boolean;
  };
}

const UserInfoPopover: React.FC<UserInfoPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  userData,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      className="user-info-popover"
    >
      <div className="user-info-content">
        <div className="user-header">
          <div className="user-avatar">
            <img src={userData.avatar} alt={`Avatar de ${userData.username}`} />
          </div>
          <div className="user-main-info">
            <h3 className="username">{userData.username}</h3>
            <p className="age">{userData.age}ans</p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-location">
            <InlineIcon icon="mdi:map-marker" />
            <div className="location-text">
              <h4>{userData.city}</h4>
              <p>{userData.country}</p>
            </div>
          </div>

          {userData.messagesLeft && userData.messageMax && (
            <div className="stat-card messages">
              <InlineIcon icon="mdi:message-text" />
              <div className="stat-info">
                <p className="stat-label">Messages restants</p>
                <p className="stat-value">
                  {userData.messagesLeft} sur {userData.messageMax}
                </p>
              </div>
            </div>
          )}

          {userData.duration && (
            <div className="stat-card duration">
              <InlineIcon icon="mdi:clock-outline" />
              <div className="stat-info">
                <p className="stat-label">En échange depuis</p>
                <p className="stat-value">{userData.duration}</p>
              </div>
            </div>
          )}

          <div
            className={`stat-card subscription ${userData.hasSubscription ? "active" : "expired"}`}
          >
            <InlineIcon icon="mdi:credit-card" />
            <div className="stat-info">
              <p className="stat-label">Abonnement</p>
              <p
                className={`stat-value ${userData.hasSubscription ? "active" : "expired"}`}
              >
                {userData.hasSubscription ? "Actif" : "Expiré"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default UserInfoPopover;
